export default __webpack_public_path__ + "static/media/D.2f57fa42.mp3";